<template>
  <v-app id="app">
    <v-main>
      <router-view />
    </v-main>
    <session-dialog></session-dialog>
  </v-app>
</template>

<script>
import SessionDialog from "@/components/SessionDialog";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    SessionDialog,
  },
  computed: {
    ...mapGetters({
      session: "session/getSession",
    }),
  },
  async created() {
    try {
      await this.loadSession();
    } catch (e) {
      console.error("Error in App.vue created hook, unable to load session");
    }

    if (this.session && this.session.loggedIn) {
      try {
        await this.loadFlags();
      } catch (e) {
        console.error(
          "Error in App.vue created hook, unable to load feature flags"
        );
      }
    }
  },
  methods: {
    ...mapActions({
      loadFlags: "featureFlag/load",
      loadSession: "session/loadSession",
    }),
  },
  name: "App",
};
</script>

<style>
/* Global Styles */

h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--v-primary-base);
}

h1 {
  font-size: 1.6rem;
  line-height: 2.4rem;
}
h2 {
  font-size: 1.4rem;
  line-height: 2.4rem;
}
h3 {
  font-size: 1.2rem;
  line-height: 2.4rem;
}
h4 {
  font-size: 1.1rem;
  line-height: 2.4rem;
}
h5 {
  font-size: 1rem;
  line-height: 2.4rem;
}
h6 {
  font-size: 0.9rem;
  line-height: 2.4rem;
}

.spinner {
  animation: spinner 2s infinite linear;
}
@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

/* Vuetify Overrides */

/* The No Data message in Vuetify data tables */
.v-data-table__empty-wrapper {
  color: #595959 !important;
}

/* Theme Light Overrides */
.theme--light.v-navigation-drawer {
  background-color: #fafafa;
}

.theme--light.v-btn.navButtons {
  color: var(--v-primary-base) !important;
}

.theme--light.v-chip {
  background-color: var(--v-primary-base) !important;
  color: white !important;
}

.theme--light.v-chip:hover {
  opacity: 1 !important;
}

.theme--light.v-chip--active:before {
  opacity: 0 !important;
}

.theme--light.v-chip:not(.v-chip--active) {
  background-color: var(--v-primary-base) !important;
  color: white !important;
}

.theme--light.v-tabs-items {
  background-color: transparent !important;
}

.v-chip {
  font-size: 0.9rem !important;
  border-radius: 5px !important;
}

.v-chip__close.v-icon {
  color: white !important;
  font-size: 1.2rem !important;
}

.v-chip__content:focus {
  border: 1px solid white !important;
}

.v-stepper__label {
  font-size: 1.1rem;
}

.v-stepper__step--active .v-stepper__label {
  color: var(--v-primary-base) !important;
}

.v-stepper__step--complete .v-stepper__label,
.v-stepper__step--inactive .v-stepper__label {
  color: var(--v-bodyText-base) !important;
}

/* Custom CSS */

.och-adminLink {
  text-decoration: none;
}

.och-homeLink {
  text-decoration: none;
  font-weight: 300;
}

.och-homeLink:hover,
.och-homeLink:focus {
  opacity: 0.8;
  border: 1px dotted white;
}

.och-label {
  color: #595959;
  display: block;
  font-weight: bold;
}

.och-label > span {
  margin-right: 10px;
}

.och-logo {
  vertical-align: middle;
  margin-right: 8px;
}

.och-field--conditional {
  border-left: 25px solid #ddd;
  padding-left: 1.8rem;
}

.och-table {
  border: 1px solid #ccc;
}

.och-tableRow {
  cursor: pointer;
}

/* Drop Zone Overrides */
div.dz-preview {
  z-index: 198 !important;
}

/* User Menu  */

.v-btn.och-button--usermenu {
  border: 1px solid transparent !important;
}

.v-btn.theme--dark.och-button--usermenu:hover,
.v-btn.theme--dark.och-button--usermenu:focus {
  border: 1px dotted white !important;
}
</style>
